import loadable from '@loadable/component';
import React from 'react';
import { Route, Switch } from 'react-router';

import { NotFound } from 'src/modules/notFound';
import { RedirectWithSession } from 'src/modules/renderings/components/RenderingsShared/RedirectWithSession';
import { Route as Routes } from 'src/shared/route';

const RenderingsHub = loadable(() => import('../RenderingsHub'), {
  resolveComponent: module => module.RenderingsHub,
});

const RenderingsShared = loadable(() => import('../RenderingsShared'), {
  resolveComponent: module => module.RenderingsShared,
});

const Router = () => (
  <Switch>
    <Route path={Routes.RENDERINGS_SHARED.path}>
      <RedirectWithSession>
        <RenderingsShared />
      </RedirectWithSession>
    </Route>
    <Route path={Routes.RENDERINGS_HUB.path}>
      <RenderingsHub />
    </Route>
    <Route path="*">
      <NotFound />
    </Route>
  </Switch>
);

export { Router };
